import React from "react";
import Typography from "@material-ui/core/Typography";
import images from "components/images";

export const EventBasics = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>Event Basics</u>
      </Typography>
      <p>
        Each mission maker will create a mission and post it on Discord about a
        week in advance of a mission. Once posted, users will be able to slot by
        using both the web application to find an applicable slot and our
        discord bot to reserve that slot. The majority of positions in the
        missions are on a first come first served basis with a minority of high
        profile positions raffled out, however there is no set limit on either
        types and depends on the missionmakers preference.
      </p>
      <p>
        Each event has it's own unique ID and can be accessed via the All Events
        page, located in the top navigation bar or at:
      </p>
      {/* <a
        href="https://slotting.combinedarms.co.uk/events"
        rel="noopener noreferrer"
        target="blank"
      >
        slotting.combinedarms.co.uk/events
      </a>
      <p>or directly via the url such as:</p>
      <a
        href="https://slotting.combinedarms.co.uk/events/96"
        rel="noopener noreferrer"
        target="blank"
      >
        slotting.combinedarms.co.uk/events/96
      </a> */}

      <Typography variant="h3" component="h2">
        Actions
      </Typography>

      <p>On the left hand side of the header you will find the actions menu.</p>
      <div className={"image"}>
        <img src={images["actions"]} alt={"actions"} />
      </div>

      <p>
        These items will often contain shortcuts of certain actions, such as
        automatically copying the reserve command (more on this later) to the
        clipboard or downloading the schema for the current mission. The content
        in this box is dynamic and can change based on if you are logged in, or
        if you are the owner of the mission.
      </p>

      <Typography variant="h3" component="h2">
        Summary
      </Typography>

      <p>On the middle of the header you will find the summary section.</p>
      <div className={"image"}>
        <img src={images["summary"]} alt={"summary"} />
      </div>

      <p>
        The summary section is designed to provide a user a quick glance of the
        overall mission, from who is has designed it to how many slots are open
        or taken.
      </p>

      <Typography variant="h3" component="h2">
        Reserves
      </Typography>

      <p>On the middle of the header you will find the reserve section.</p>
      <div className={"image"}>
        <img src={images["reserves"]} alt={"reserves"} />
      </div>

      <p>
        Not sure if you can make an event but want to show your support for it?
        The reserves are for you!
      </p>
      <p>
        The reserve system is designed to allow players to show an interest in a
        particular event without formally signing up and taking a slot that
        another player who can attend might want. The priority for slots is as
        follows:
      </p>
      <p>
        <strong>Slotted Users </strong>
        {`>`} <strong>Reserved Users </strong>
        {`>`} <strong>Users who show up without slotting or reserving.</strong>
      </p>
      <p>
        This means that if you decide to reserve and show up, you have priority
        on slots over those who just turn up on the day.
      </p>
      <p>
        <i>
          Clicking on the reserves box will also automatically copy the reserve
          command to your clipboard.
        </i>
      </p>

      <Typography variant="h3" component="h2">
        Briefing
      </Typography>

      <p>Below the header you will find the breifing toggle switch.</p>
      <div className={"image"}>
        <img src={images["briefing"]} alt={"briefing"} />
      </div>

      <p>
        The Briefing gives the players some context before entering a mission,
        it might contain information like the AO (Area of Operations), assets
        (both enemy and friendly) as well as objectives. There are no rules for
        missionmakers how detailed or complex a briefing must be, so results can
        vary depending on the style of the mission or amount of effort put into
        it. Toggling the button will show an embedded google document. If there
        is no such document attached to the toggle will automatically hide from
        view.
      </p>
    </div>
  );
};

export default EventBasics;
